export default __webpack_public_path__ + "static/media/PrattTrussImg.68fef6df.png";